import type { HeroSlide } from "@/types/video";

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-1",
    videoId: "v2005",
    title: "星尘之约",
    subtitle:
      "相隔光年的两个人，用一段延迟二十年的信号彼此守候。年度最值得期待的科幻爱情巨制，正在热映。",
    badge: "网络电影 · 独家首发",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20wide%20shot%20of%20a%20starry%20night%20sky%20with%20a%20glowing%20distant%20planet%20over%20a%20quiet%20mountain%20silhouette%20deep%20warm%20tones%20moody%20atmosphere%20high%20detail%20film%20poster%20style&width=1600&height=900&seq=cv-hero-01&orientation=landscape",
  },
  {
    id: "hero-2",
    videoId: "v3002",
    title: "歌手对决",
    subtitle:
      "八位实力歌手同台飙歌，高音与情感轮番轰炸。本季最强现场，票选冠军一触即发。",
    badge: "娱乐综艺 · 每周更新",
    image:
      "https://readdy.ai/api/search-image?query=Live%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20a%20lone%20microphone%20energetic%20crowd%20atmosphere%20cinematic%20wide%20shot%20high%20detail%20editorial%20quality&width=1600&height=900&seq=cv-hero-02&orientation=landscape",
  },
  {
    id: "hero-3",
    videoId: "v1004",
    title: "猫咪第一次见到雪",
    subtitle:
      "从好奇到兴奋再到一脸茫然，家里的猫第一次出门看雪，每一个表情都治愈满分。",
    badge: "短视频 · 编辑精选",
    image:
      "https://readdy.ai/api/search-image?query=Curious%20fluffy%20cat%20pawing%20at%20fresh%20white%20snow%20on%20a%20bright%20winter%20morning%20soft%20warm%20light%20cinematic%20wide%20shot%20high%20detail%20editorial%20quality&width=1600&height=900&seq=cv-hero-03&orientation=landscape",
  },
  {
    id: "hero-4",
    videoId: "v2001",
    title: "暗夜追光",
    subtitle:
      "一名普通快递员深夜卷入追逐战，霓虹街头展开生死博弈。节奏紧凑，动作戏全程高能。",
    badge: "网络电影 · 热播中",
    image:
      "https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20a%20lone%20silhouette%20and%20warm%20reflections%20cinematic%20tense%20mood%20wide%20shot%20high%20detail%20editorial%20quality&width=1600&height=900&seq=cv-hero-04&orientation=landscape",
  },
];